<!--Tarjeta que contiene una imagen y texto, se pueden obserar estas tarjetas en la vista de How It's works (¿Cómo funciona?)-->
<template>
    <v-card class="fill-height card-rounded" :color="(theme=='dark')?'primary':(theme=='normal')?'secondary':''" v-bind:class="[(theme=='light')?'':'white--text', padding, margin, (!hover)?'':'card-rounded-hover']">
        <v-row justify="center" align="center" class="fill-height text-center">
            <v-col cols="12">
                <v-icon x-large :color="iconColor" v-bind:style="getSize">{{ data.icon }}</v-icon>
            </v-col>
            <v-col cols="12" class="pt-0">
                <h1 class="font-weight-bold headline">{{ data.description }}</h1>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
export default {
    /* 
    PROPIEDADES DEL COMPONENTE
    - data - Objeto con las siguientes propiedades:
        1. icon: String - Requerido - Texto con el nombre del ícono que se desea mostrar, ya sea de Material Design ( EJ. arrow_right_alt ) o Font Awesome ( EJ. fas fa-arrow-right )
        2. description: String - Requerido -- Texto de la tarjeta
    - theme - dark ( Fondo primary y texto blanco ), normal (Fondo secondary, texto blanco) ó light ( Fondo blanco y texto negro )
    - iconColor - Color del Icono
    - padding - Clases para agregar paddings personalizados ( EJ. pa-5 pb-3 ) 
    - margin - Clases para agregar margins personalizados ( EJ. ma-3 mt-5 )
    */
    props:{
        data: { type: Object, required:true },
        theme:{ type: String, required:true },
        iconColor: { type:String, required:true },
        padding: { type:String, required:false },
        margin: { type:String, required:false },
        hover: { type:Boolean, required:false }         
    }, 
    computed:{
        getSize(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'font-size:2.5em'
                case 'sm': return 'font-size:3em'
                case 'md': return 'font-size:3em'
                case 'lg': return 'font-size:3.3em'
                case 'xl': return 'font-size:3.5em'
            }
        }
    }
}
</script>
<style scoped>
    .card-rounded{
        border-radius:25px!important;
    }

    .card-rounded-hover{
        transition: all .2s;
    }

    .card-rounded-hover:hover{
        transform: scale(1.05)
    }
</style>